module.exports = __webpack_public_path__ + "assets/img/rotate.0b6e5eae.svg";